import avatar1 from "../../../../../../assets/images/LearningSession/avatar1.png";
import {
  default as avatar2,
  default as avatar3,
} from "../../../../../../assets/images/LearningSession/avatar2.png";

export const allData = [
  {
    photo: <img width="60" height="60" src={avatar1} alt="" />,
    name: "Al Amin",
    mobile: "01635431430",
    rank: 23,
    action: <i className="fa-solid fa-pen-to-square text-info"></i>,
  },
  {
    photo: <img width="60" height="60" src={avatar2} alt="" />,
    name: " Joti",
    mobile: "01635431430",
    rank: 23,
    action: <i className="fa-solid fa-pen-to-square text-info"></i>,
  },
  {
    photo: <img width="60" height="60" src={avatar3} alt="" />,
    name: "Aktaruzzaman Joti",
    mobile: "01635431430",
    rank: 23,
    action: <i className="fa-solid fa-pen-to-square text-info"></i>,
  },
 
];
